/* eslint-disable react/prop-types */
import {
  CameraOutlined,
  DownloadOutlined,
  FileGifOutlined,
  FileImageOutlined,
  LoadingOutlined,
  SaveOutlined,
} from '@ant-design/icons'


import { getDomainID, getToken, qaBackendApiInstance } from '../../../../config/config'
import { useGlobalContext } from '../../../../context/globalContext'
import { trackEvent } from '../../../../lib/mixpanel'
import { Button, Dropdown, Menu, Modal, Progress, Result, Select, Spin, message } from 'antd'

import { useEffect, useState } from 'react'

import {
  creditsDeduct,

  getUserDetails,
} from '../../../../shared/utils/VideoGeneration/helperFunctions/mediaSearch'
import { generateUniqueId, handlePutImage } from '../../../../shared/utils/core'

import io from 'socket.io-client'

import { downloadFilesAsZip } from '@src/shared/utils/saveAssetsZip/saveAssetsZip'
import useSaveLog from '@src/api/logs/useSaveLogs'

import { getElementIdJsonPage } from '@src/shared/utils/findReplicaJson'
// import { PreviewButtonSection } from "../previewStory";
import { avatarRendering, updateVideos } from '@src/shared/utils/VideoGeneration/helperFunctions/aiAvatarAsync'
import { IS_FREE_PLATFORM } from '@src/config'
import { PreviewButton } from '../previewContainer'
import { UpgradeOverlay } from '@src/shared/components/upgradeOverlay'


const socket = io('https://videos-node-be.quickads.ai/')
interface DownloadProps {
  store: any // Ideally, replace `any` with a more specific type
  open: boolean
  setOpen: any
  bulkCreatePropsArray: any
  setBulkCreatePropsArray: any
  previewOpen: boolean
  setPreviewOpen: any
  setProgressBarPercentage: any
}

export const CustomActionControlContainer: React.FC<DownloadProps> = ({
  store,
  open,
  setOpen,
  bulkCreatePropsArray,
  setBulkCreatePropsArray,
  previewOpen,
  setPreviewOpen,
  setProgressBarPercentage,
}) => {
  const {
    UserDetail: [userDetails],
    UpdatedHeadings: [heading],
    TransitionAnimation: [transitionAnimation],
    ScriptDetails: [scriptDetails],
    VideoStyle: [videoStyle],
    CurrentUserData: [currentUserData],
    AvatarTasks: [avatarTasks, setAvatarTasks],
    ShowAdvancedEditor: [, setShowAdvancedEditor],
    VideoRenderStatus: [videoRenderStatus, setVideoRenderStatus],
  } = useGlobalContext()
  const projectID = location.pathname.split('/').pop()

  const User = JSON.parse(localStorage.getItem('userData') as string)

  // update and save as new button loading animation
  const [isUpdateLoading, setUpdateLoading] = useState<boolean>(false)
  const [isSaveAsNewLoading, setSaveAsNewLoading] = useState<boolean>(false)
  const [downloadModal, setDownloadModal] = useState(false)
  const [isdownloadLink, setIsDownloadLink] = useState(false)
  const [renderprogress, setRenderProgress] = useState(0)
  const [renderBegins, setRenderBegins] = useState(false)
  const [downloadPercentage, setDownloadPercentage] = useState(0)
  const [isDownloadingIndividual, setIsDownloadingIndividual] = useState(false)
  const [avatarTriggered, setAvatarTriggered] = useState(false)
  // menu states
  const [saveMenuVisible, setSaveMenuVisible] = useState(false)

  // save As new
  const [creationSuccess, setCreationSuccess] = useState(false)
  const [newProjectID, setNewProjectID] = useState('')
  const [remotionDownloadUrl, setDownloadUrl] = useState('')
  // downloding mp4
  const [isMp4Downloding, setIsMp4Downloading] = useState<boolean>(false)
  const [generateuniqueRoomId, setGenerateUniqueRoomId] = useState('')
  const [showRecentVideoModal, setShowRecentVideoModal] = useState<boolean>(false)
  const [showUpgradeOverlay, setShowUpgradeOverlay] = useState<boolean>(false)


  useEffect(() => {
    setRenderProgress(0)
    setDownloadPercentage(0)
    const roomId = generateUniqueId() // Generate or get a unique room ID
    setGenerateUniqueRoomId(roomId)
    socket.emit('joinRoom', roomId)
    socket.on('progress', (data: { percentage: number }) => {
      setRenderProgress(data.percentage)
      // setRenderProgress(data.percentage)
    })

    return () => {
      socket.off('progress')
    }
  }, [])
  async function deductCredits() {
    try {
      const response = await creditsDeduct('video_credits', 1)
    } catch (error) {
      message.error('Something went wrong!')
    }
  }

  // for handling the result screen
  const handleGoToNewProject = () => {
    window.location.href = `/${newProjectID}`
  }

  const handleStay = () => {
    setCreationSuccess(false) // Optionally reset or handle as needed
  }

  // for handling the state of save menu
  const handleMenuClick = (e: { domEvent: { stopPropagation: () => void } }) => {
    e.domEvent.stopPropagation() // Stop the menu from closing
  }

  // Download image
  const handleDownloadImage = async () => {
    const savePromises = store.pages.map((page: { id: string }) => store.saveAsImage({ pageId: page.id }))

    try {
      await Promise.all(savePromises)
    } catch (error) {
      console.error('Error saving one or more pages as images:', error)
    }
  }

  // Download gif
  const handleDownloadGif = async () => {
    trackEvent('Free Video Ad Downloaded')
    await store.saveAsGIF()
  }
  

  const waterMarkedAsset: { id: any; src: any }[] = []

  

  const fetchReplicIds = async () => {
    message.success('Fetching avatar. This may take a few minutes.')
    await getElementIdJsonPage(store.toJSON(), scriptDetails, userDetails, setAvatarTasks, setAvatarTriggered)

    // if(ava)
  }

  

  const handleDownloadMp4 = async (downloadVideo: boolean) => {
    // Check if user is new and show upgrade overlay
    if (!currentUserData?.isAllowedToEdit) {
      message.warning('Please upgrade to render the video.')
      setShowUpgradeOverlay(true)
      return
    }

    setIsMp4Downloading(true)
    const avatarRenderResponse = await avatarRendering(
      store,
      scriptDetails,
      userDetails,
      videoStyle,
      transitionAnimation,
      projectID
    )
    if (avatarRenderResponse) {
      setVideoRenderStatus({
        task_id: avatarRenderResponse.task_id,
        video_url: '',
        status: '',
        progressPer: 0,
      })
      message.info(
        'Video rendering has started. We will notify you with the download link via email once it is completed.'
      )
      setIsMp4Downloading(false)
      return
    } else {
      // message.info('Failed to render')
      setIsMp4Downloading(false)
      return
    }
  }

  const renderAndSave = async () => {
    await handleDownloadMp4(false)
    updateProject()
  }
  function setBackToWaterMark(waterMarkedAsset: any) {
    for (const page of store.pages) {
      for (const child of page.children) {
        if (child.type === 'video') {
          const element = store.getElementById(child.id)
          for (const obj of waterMarkedAsset) {
            if (obj.id === child.id) {
              element.set({ src: obj.src })
            }
          }
        }
      }
    }
    waterMarkedAsset = []
  }

  const error = () => {
    Modal.error({
      title: 'Render Failed',
      content: 'Please try again after loading all the pages.',
    })
  }

  // update project api call put call
  async function updateProject(): Promise<any> {
    // Check if user is new and show upgrade overlay
    if (!currentUserData?.isAllowedToEdit) {
      message.warning('Please upgrade to save your project.')
      setShowUpgradeOverlay(true)
      return
    }

    setUpdateLoading(true)
    try {
      const payload = userDetails
      payload.json_body = store.toJSON()

      payload.script = scriptDetails
      payload.first_render = false
      const domainID = getDomainID() || ''
      const response = await qaBackendApiInstance.put(
        `/smp/${userDetails.id}?domain_id=${encodeURIComponent(domainID)}`,
        { ...payload }
      )
      if (response.status === 200) {
        message.success('Project updated successfully', 5)
        setUpdateLoading(false)
        // Handle successful upload, e.g., update state, display message, etc.
      } else {
        message.error('Project could not be updated', 5)
        // Handle non-200 responses
      }
    } catch (error) {
      console.error('Error updating project:', error)
      message.error('Project could not be updated.')
    }
  }

  // save as new api call post call
  const createNewProject = async (userDetails: any): Promise<any> => {
    // Check if user is new and show upgrade overlay
    if (!currentUserData?.isAllowedToEdit) {
      message.warning('Please upgrade to create new projects.')
      setShowUpgradeOverlay(true)
      return
    }

    trackEvent('Free Video Ad Generated')

    setSaveAsNewLoading(true)
    try {
      const payload = {
        ...userDetails,
        heading: heading.heading,
        subHeading: heading.subHeading,
        third_heading: heading.thirdHeading,
        domain_id: getDomainID(),
      }
      payload.json_body = store.toJSON()
      delete payload.id

      const response = await qaBackendApiInstance.post(
        `/smp/save-new-ad/${userDetails.id}`,
        payload
      )
      // Guard: Polotno throws "No page for export with id undefined" if there is no active page
      if (!store.activePage || !store.pages?.length) {
        message.error('Canvas is not ready. Please wait and try again.')
        setSaveAsNewLoading(false)
        return
      }
      const blob = await store.toBlob({ mimeType: 'image/jpg' })
      const file = new File([blob], 'preview.jpg')
      const formData = new FormData()
      formData.append('file', file)

      await qaBackendApiInstance.post(
        `/smp/save-ad-image/${response.data.project_id}?domain_id=${getDomainID()}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )

      // setting the new project id after creating a new project
      setNewProjectID(response.data.project_id)
      setCreationSuccess(true) // Indicate success to show the Result component
      setSaveAsNewLoading(false)
      setSaveMenuVisible(false)
    } catch (error) {
      console.error('Error uploading file:', error)
      message.error('Upload failed.')
      setSaveAsNewLoading(false)
    }
  }
  const handleCloseDownload = () => {
    setIsDownloadLink(false)
  }

  const handleDownloadAssets = async () => {
    setIsDownloadingIndividual(true)
    const getCredits = await getUserDetails()

    if (getCredits == -1) {
      message.warning('Something went wrong!')
      setIsDownloadingIndividual(false)
      return
    }

    if (getCredits?.video_limit < 1) {
      message.warning('Video credits have been exhausted. Please upgrade the plan to download the video.')
      setIsDownloadingIndividual(false)
      return
    }

    await updateVideos(store)

    const jsonData = store.toJSON()
    const audioFiles: any = []
    const imageFiles: any = []
    const videoFiles: any = []
    const backgroundMusic = scriptDetails?.backgroundMusic?.url

    let imageCounter = 0
    let videoCounter = 0

    for (let pageIndex = 0; pageIndex < jsonData.pages.length; pageIndex++) {
      const page = jsonData.pages[pageIndex]

      // Add audio file from custom sounds (if available)
      const audioUrl = page?.custom?.sounds?.[0]?.url
      if (audioUrl) {
        audioFiles.push({
          name: `Ai voice scene ${pageIndex + 1}`,
          url: audioUrl,
        })
      }

      // Iterate over the children in each page
      for (let childIndex = 0; childIndex < page.children.length; childIndex++) {
        const child = page.children[childIndex]

        if (child.type === 'image') {
          imageFiles.push({
            name: `Image ${imageCounter + 1}`,
            url: child.src,
          })
          imageCounter++ // Increment global image counter
        }

        if (child.type === 'video') {
          videoFiles.push({
            name: `Video ${videoCounter + 1}`,
            url: child.src,
          })
          videoCounter++ // Increment global video counter
        }
      }
    }

    audioFiles.push({ name: 'Background music', url: backgroundMusic })

    await downloadFilesAsZip(audioFiles, imageFiles, videoFiles)

    await deductCredits()
    // setBackToWaterMark(waterMarkedAsset)
    setBackToWaterMark(store)
    setIsDownloadingIndividual(false)
  }
  // download menu drop down which contains download as mp4 or downlaoad as gif
  const downloadMenu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key='3' icon={<FileGifOutlined style={{ fontSize: '25px' }} />} onClick={handleDownloadGif}>
        Download as GIF
      </Menu.Item>
      <Menu.Item
        key='3'
        icon={
          isMp4Downloding ? (
            <LoadingOutlined style={{ fontSize: '25px' }} />
          ) : (
            <CameraOutlined style={{ fontSize: '25px' }} />
          )
        }
        onClick={() => handleDownloadMp4(true)}
        disabled={isMp4Downloding}
      >
        Download as MP4
      </Menu.Item>
    </Menu>
  )

  // drop down for save menu
  const saveMenu = {
    onClick: handleMenuClick,
    items: [
      {
        key: '1',
        icon: isUpdateLoading ? (
          <LoadingOutlined style={{ fontSize: '25px' }} />
        ) : (
          <FileImageOutlined style={{ fontSize: '25px' }} />
        ),
        label: 'Update',
        onClick: () => updateProject()
      },
      {
        key: '2',
        icon: isSaveAsNewLoading ? (
          <LoadingOutlined style={{ fontSize: '25px' }} />
        ) : (
          <FileImageOutlined style={{ fontSize: '25px' }} />
        ),
        label: 'Save as new',
        onClick: () => createNewProject(userDetails)
      },
      {
        key: '4',
        icon: isDownloadingIndividual ? (
          <LoadingOutlined style={{ fontSize: '25px' }} />
        ) : (
          <FileImageOutlined style={{ fontSize: '25px' }} />
        ),
        label: 'Extract Video & Audio',
        onClick: handleDownloadAssets
      }
    ]
  }

  const handleRederModalClose = () => {
    setRenderBegins(false)
    if (renderprogress >= 100 && downloadPercentage >= 100) {
      setRenderProgress(0)
      setDownloadPercentage(0)
    }
  }

  const downloadComplete = () => {
    setRenderBegins(false)
    setRenderProgress(0)
    setDownloadPercentage(0)
    // setBackToWaterMark(waterMarkedAsset);
    deductCredits()
  }

  // Handle upgrade overlay actions
  const handleUpgrade = () => {
    // TODO: Implement upgrade logic - redirect to pricing page or open upgrade modal
    console.log('User clicked upgrade')
    setShowUpgradeOverlay(false)
  }

  const handleDismissUpgrade = () => {
    setShowUpgradeOverlay(false)
  }
  return (
    <>
      <div className={'custom-action-container'}>
      <PreviewButton 
          store={store} 
          previewOpen={previewOpen}
          setPreviewOpen={setPreviewOpen}
        />

        {IS_FREE_PLATFORM === 'false' && (
          <Dropdown
            menu={saveMenu}
            trigger={['click']}
            onOpenChange={(flag) => setSaveMenuVisible(flag)}
            open={saveMenuVisible}
          >
            <Button
              onClick={(e) => e.preventDefault()}
              icon={<SaveOutlined />}
              style={{
                background: 'transparent',
                borderColor: 'var(--color-border)',
                marginRight: '8px',
                marginLeft: '8px',
                color: 'var(--color-ink-2)',
              }}
            >
              Save
            </Button>
          </Dropdown>
        )}
        {/* <Dropdown overlay={downloadMenu} trigger={['click']}> */}
        {videoRenderStatus.task_id ? (
          <Button
            icon={<LoadingOutlined />}
            style={{
              background: 'var(--gradient-primary)',
              borderColor: 'transparent',
              color: 'white',
              // marginBottom: "10px",
            }}
            onClick={() => handleDownloadMp4(true)}
            disabled={true}
          >
            {videoRenderStatus.progressPer}% Rendering
          </Button>
        ) : (
          <Button
            icon={isMp4Downloding ? <LoadingOutlined /> : <DownloadOutlined />}
            style={{
              background: 'var(--gradient-primary)',
              borderColor: 'transparent',
              color: 'white',
              // marginBottom: "10px",
            }}
            onClick={() => handleDownloadMp4(true)}
          >
            Render
          </Button>
        )}

        {/* Recent Video Button - only show if remotionUrl exists */}
        {store.custom?.remotionUrl && (
          <Button
            icon={<FileImageOutlined />}
            style={{
              background: 'transparent',
              borderColor: 'var(--color-border)',
              color: 'var(--color-ink-2)',
              marginLeft: '8px',
            }}
            onClick={() => setShowRecentVideoModal(true)}
          >
            Last Video
          </Button>
        )}

        {/* </Dropdown> */}
        {creationSuccess && (
          <div
            style={{
              position: 'fixed', // Or 'absolute'
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Overlay effect
              zIndex: 1000, // Ensure it's above other content
            }}
          >
            <div
              style={{
                padding: '20px',
                maxWidth: '600px',
                width: '90%',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              }}
            >
              <Result
                status='success'
                title='Successfully Created New Project!'
                subTitle={`Project ID: ${newProjectID}. You can now navigate to the new project or stay on this page.`}
                extra={[
                  <Button type='primary' key='goNewProject' onClick={handleGoToNewProject}>
                    Go to New Project
                  </Button>,
                  <Button key='stay' onClick={handleStay}>
                    Stay on This Page
                  </Button>,
                ]}
              />
            </div>
          </div>
        )}
      </div>

      <Modal open={downloadModal} title='Rendering Video' footer={(_, { OkBtn, CancelBtn }) => <></>}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Spin />
        </div>
        <p>This will take a few minutes. </p>
        <p>Your download will start as soon as it is done.</p>
      </Modal>

      <Modal open={isdownloadLink} title='Download video' onOk={handleCloseDownload} onCancel={handleCloseDownload}>
        <p>Your video is ready to download</p>
        <a href={remotionDownloadUrl}>Click here to download</a>
        {/* <Spin/> */}
      </Modal>

      <Modal
        open={renderBegins}
        title='Video render'
        width={400}
        onCancel={handleRederModalClose}
        footer={(_, { OkBtn, CancelBtn }) => <></>}
      >
        {renderprogress >= 100 ? (
          <>
            {/* {downloadPercentage > 0 ? (
              <>
                {downloadPercentage >= 100 ? (
                  <p style={{ fontWeight: 'bold' }}>Video Downloaded</p>
                ) : (
                  <p style={{ fontWeight: 'bold' }}>Downloading video</p>
                )}
              </>
            ) : (
              <p style={{ fontWeight: 'bold' }}>
                Rendered successfully
              </p>
            )} */}
            {''}
          </>
        ) : (
          <>
            <p style={{ fontWeight: 'bold' }}>
              Rendering your video in the background. This will take a few minutes. Your download will start as soon as
              it is done.
            </p>
          </>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: '3px',
            }}
          >
            <div>
              <p style={{ fontWeight: 'bold' }}>Render status</p>
              <Progress type='circle' percent={renderprogress} strokeColor='#4096ff' />
            </div>
            {/* <div>
              <p style={{ fontWeight: 'bold' }}>Download status</p>
              <Progress
                type='circle'
                percent={downloadPercentage}
                strokeColor='#52c41a'
              />
            </div> */}
            {remotionDownloadUrl.length > 1 && (
              <a
                href={remotionDownloadUrl}
                style={{
                  marginTop: '10px',
                  display: 'inline-block',
                  padding: '4px 15px',
                  background: 'var(--gradient-primary)',
                  borderColor: 'transparent',
                  color: 'white',
                  marginBottom: '10px',
                  textDecoration: 'none',
                  textAlign: 'center',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  downloadComplete()
                }}
              >
                Download
              </a>
            )}
            <div></div>
          </div>
        </div>
        {/* {renderprogress >= 100 ? (
          <>
           {downloadPercentage > 0 ? ( <div style={{display:'flex', justifyContent:'center'}}>
            <span>Not downloading?<a style={{paddingLeft:'10px'}} href={remotionDownloadUrl}  onClick={ ()=>{
              setRenderBegins(false)
              setRenderProgress(0)
              setDownloadPercentage(0)
              setBackToWaterMark(waterMarkedAsset);
              cancelDownload()
            }}>Click here</a></span>
            </div>):''}
          </>
        ):''} */}
      </Modal>

      {/* Recent Video Modal */}
      <Modal
        open={showRecentVideoModal}
        title="Recent Video"
        width={600}
        onCancel={() => setShowRecentVideoModal(false)}
        footer={null}
        centered
      >
        <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0' }}>
          {store.custom?.remotionUrl && (
            <video
              controls
              autoPlay
              style={{
                width: '100%',
                maxWidth: '500px',
                height: 'auto',
                maxHeight: '350px',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              }}
            >
              <source src={store.custom.remotionUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </Modal>

      {/* Upgrade Modal for new users */}
      <Modal
        open={showUpgradeOverlay}
        onCancel={handleDismissUpgrade}
        footer={null}
        closable={false}
        centered
        width={500}
        mask={true}
        maskClosable={false}
        getContainer={() => document.body}
        className="upgrade-modal"
        maskStyle={{
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(4px)'
        }}
        style={{ 
          top: 0,
          margin: 0,
          padding: 0,
          background: 'transparent'
        }}
        bodyStyle={{
          padding: 0,
          margin: 0,
          background: 'transparent'
        }}
      >
        <UpgradeOverlay 
         
          onDismiss={handleDismissUpgrade}
          isModal={true}
        />
      </Modal>
    </>
  )
}
